import { Dropdown } from 'flowbite'

// Guardar la función original
const originalInit = Dropdown.prototype.init

Dropdown.prototype.init = function () {
  const placement = this._options.placement || 'bottom'

  if (placement.startsWith('bottom')) {
    // Solo clases para fade
    this._targetEl.classList.add(
      'transition-opacity',
      'duration-500',        // más lento
      'ease-out',
      'opacity-0'
    )

    this._options = {
      ...this._options,
      onShow: () => {
        requestAnimationFrame(() => {
          this._targetEl.classList.remove('opacity-0')
          this._targetEl.classList.add('opacity-100')
        })
      },
      onHide: () => {
        this._targetEl.classList.remove('opacity-100')
        this._targetEl.classList.add('opacity-0')
      }
    }
  }

  originalInit.call(this)
}
